/**
 * 检查用户是否是超级管理员
 * @returns {boolean}
 */
export function isSuperuser() {
    return localStorage.getItem('isSuperuser') === 'true'
}

/**
 * 检查权限的兼容方法（保持接口一致）
 * @param {string} _ 忽略参数
 * @returns {boolean}
 */
export function hasPermission(_) {
    return isSuperuser()
}